import { render, staticRenderFns } from "./detalleProducto.vue?vue&type=template&id=519519bd&"
import script from "./detalleProducto.vue?vue&type=script&lang=js&"
export * from "./detalleProducto.vue?vue&type=script&lang=js&"
import style0 from "./detalleProducto.vue?vue&type=style&index=0&id=519519bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports